<sidebar-envelope-document (menu)="onNotify($event)" [openDocumentDetails]="isOpen" [document]="documentOpened"
  [employee]="uuid"></sidebar-envelope-document>
<section *ngIf="documents.length; else loadingOrError">
  <ng-container>
    <div class="container-list">
      <div class="list-header-wrapper">
        <div class="list-title">Assinaturas</div>
        <a (click)="shippingDocuments();" type="button" class="btn-wrapper blue"
          [ngClass]="{ 'hidden': !enableSimpleShippingComponent }">
          <div class="img-wrapper">
            <img class="item-main-infos icon" src="/assets/images/ico-send-white.svg" alt="Enviar assinatura" />Enviar
            documento
          </div>
        </a>
      </div>
      <div class="list-headers-container">
        <ul class="list-dashboard-headers">
          <li class="item-filter-dashboard">Nome</li>
          <li class="item-filter-dashboard">Status</li>
          <li class="item-filter-dashboard">Categoria</li>
          <li class="item-filter-dashboard">Enviado em</li>
          <li class="item-title-actions">Ações</li>
        </ul>
      </div>
      <section class="home-dashboard-list">
        <div *ngIf="!enableSignaturesListComponent; else signaturesComponent">
          <app-item-envelope-document class="item-envelope-document"
            *ngFor="let document of documents | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItems } let i = index;"
            [item]="document" 
            [employee]="uuid"
            (openDocumentData)="openDetails(document)"></app-item-envelope-document>
        </div>
        <ng-template #signaturesComponent>
          <div class="hiden" *ngFor="let document of documents | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItems } let i = index;"></div>
          <signatures-by-document #signatures></signatures-by-document>
        </ng-template>
        <div id="signatures-list"></div>        
      </section>
      <div class="pagination --rounded">
        <ng-container>
          <pagination-controls (pageChange)="onChange($event)" previousLabel="Anterior" nextLabel="Próximo">
          </pagination-controls>
        </ng-container>
      </div>
    </div>
  </ng-container>
</section>
<ng-template #loadingOrError>
  <div *ngIf="error$ | async as error; else loading" class="home-loading error-loading">
    <div *ngIf="error.status === 500">
      <img src="/assets/images/core/ico-erro.svg" alt="Erro ao carregar a lista de documentos"
        class="animated fadeInDown">
      <div class="animated fadeInUp">
        <p>Erro ao carregar a lista de documentos.</p>
        <p>Por favor, tente novamente mais tarde.</p>
        <small>500 - Erro Interno</small>
      </div>
    </div>
    <div *ngIf="error.status === 403">
      <img src="assets/images/ico-erro.svg" alt="Você não tem permissão para visualizar esta página"
        class="animated fadeInDown">
      <div class="animated fadeInUp">
        <p>Você não tem permissão para visualizar esta página.</p>
        <small>403 - Acesso Negado</small>
      </div>
    </div>
  </div>
  <ng-template #loading>
    <div *ngIf="isLoading">
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
    <div *ngIf="totalItems === 0 && !isLoading" class="list-dashboard-people">
      <div class="no-items">
        <img src="/assets/images/ico-empty-models.svg" alt="Nenhum registro encontrado">
        <p>Este colaborador não possui nenhuma assinatura.</p>
      </div>
      <a (click)="shippingDocuments();" type="button" class="btn-wrapper blue"
        [ngClass]="{ 'hidden': !enableSimpleShippingComponent }">
        <div class="img-wrapper">
          <img class="item-main-infos icon" src="/assets/images/ico-send-white.svg" alt="Enviar assinatura" />Enviar
          documento
        </div>
      </a>
    </div>
  </ng-template>
</ng-template>